import React from "react";

export const COMPANIES = {
  worker: React.lazy(() => import("./worker")),
};
